// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cb_container[data-v-0fbaba7c] {\n  font-size: 15px;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n.checkboxes[data-v-0fbaba7c] {\n  background-color: rgb(109, 109, 109);\n  padding: 6px 15px;\n  margin: 3px 0;\n}\n", ""]);
// Exports
module.exports = exports;
